var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPharmuniLogo24X24 = function SvgPharmuniLogo24X24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    d: "M14.886 3.901v9.287l2.055-1.961V7.739c.01-1.569-.811-2.968-2.055-3.838ZM11.976 3c-.322 0-.633.032-.933.085v13.771l1.888-1.802V3.084A5.607 5.607 0 0 0 11.976 3ZM8.61 4.25C7.623 5.12 7 6.36 7 7.738v12.965l2.088-1.993V3.89a5.056 5.056 0 0 0-.477.36Z"
  })));
};
export default SvgPharmuniLogo24X24;